import { styled } from '@linaria/react';

import { visualHideScrollbar } from '~theme/snippets';

export const Wrapper = styled.div`
	${visualHideScrollbar};
	display: flex;
	overflow: auto;
	width: 100%;
	height: 100%;
	flex-direction: column;
	padding: 1.2rem 0.8rem;
	border-radius: var(--radius-l);
	backdrop-filter: blur(25px);
	background-color: var(--color-grey-6-xl);
`;

export const StyledGroup = styled.div`
	position: relative;
	padding-top: 1.2rem;
	padding-bottom: 1.2rem;

	&:not(:first-child)::after {
		position: absolute;
		top: 0;
		left: 1.2rem;
		display: block;
		width: calc(100% - 2.4rem);
		border-top: 1px var(--color-grey-19-solid) solid;
		content: '';
	}
`;
